'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _redial = require('redial');

var _reactRouter = require('react-router');

var _request = require('redux/modules/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentTransitionNo = 0;
// import Progress from 'react-progress-2';

exports.default = function (store) {
  return function (prevState, nextState, replaceState, callback) {
    if (!__CLIENT__) return callback();

    var routes = nextState.routes,
        params = nextState.params,
        _nextState$location = nextState.location,
        pathname = _nextState$location.pathname,
        query = _nextState$location.query;

    var components = routes.map(function (r) {
      return r.component;
    });

    var locals = {
      path: pathname,
      pathname: pathname,
      query: query,
      params: params,

      // Allow lifecycle hooks to dispatch Redux actions
      store: store
    };

    var thisTransitionNo = ++currentTransitionNo;

    // transitioning on client
    // if (prevState) {
    //   Progress.show();
    // }

    var fetch = (0, _redial.trigger)('fetch', components, locals).then(function () {
      // Progress.hide();

      if (currentTransitionNo == thisTransitionNo) {
        callback();

        (0, _setImmediate3.default)(function () {
          store.dispatch((0, _request.request)());
        });
      }
    }).catch(function (error) {
      // Progress.hide();
      console.error(error.message);
      if (error.message !== 'User not logged in' && error.statusCode !== 401) {
        store.dispatch((0, _request.request)({ status: 404 }));
      }

      callback();
    });

    var defer = (0, _redial.trigger)('defer', components, locals);
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/redialOnRouterEvent.js
// module id = 2979
// module chunks = 0